import React from 'react';
import PropTypes from 'prop-types';
import classes from './styles.module.scss';

const FilterButton = ({
  onClick, activeValue, label, buttonsData, height, fontWeight, disableActiveButton,
}) => (
  <div className={classes.wrapper}>
    {label && <div className={classes.label}>{label}</div>}

    <div className={`${classes.btn_wrapper} ${buttonsData.length === 1 ? classes.one_btn : ''}`}>
      {buttonsData.map(({
        title, key, value, width,
      }) => (
        <button
          type="button"
          key={title}
          style={{
            width: `calc(100% / ${buttonsData.length})`,
            minWidth: width || 'auto',
            height,
            fontWeight,
            pointerEvents: (disableActiveButton && activeValue === value) ? 'none' : 'auto',
          }}
          onClick={() => onClick(key, value)}
          className={activeValue === value ? classes.active : ''}
        >
          {title}
        </button>
      ))}
    </div>
  </div>
);

FilterButton.propTypes = {
  buttonsData: PropTypes.array.isRequired,
  label: PropTypes.string,
  fontWeight: PropTypes.number,
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  activeValue: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disableActiveButton: PropTypes.bool,
};

FilterButton.defaultProps = {
  label: '',
  activeValue: '',
  height: 50,
  fontWeight: 500,
  disableActiveButton: false,
};

export default FilterButton;
